import React from 'react';
import Button from 'components/Buttons/Button';
import Icon from 'components/Icon';

export default function SaveButton({ saveAction, iconOnly = false, color, size, children }) {
  return  (<Button primary icon="save" onClick={saveAction}>
      { 'Save Changes'}
  </Button> );
}
